import { LoaderResource, Texture } from 'pixi.js'
import { Dict } from '@pixi/utils'

import { dustParticleConfig } from '../../data/particles'
import spritePool from '../spritePool'
import { Emitter } from '@pixi/particle-emitter'

let elapsedDust = performance.now()

export const initParticles = (resources: Dict<LoaderResource>) => {
	dustParticleConfig.behaviors.push({
		type: 'textureSingle',
		config: {
			texture: resources.dustParticle.texture ?? Texture.WHITE,
		},
	})
	spritePool.dustEmitter = new Emitter(spritePool.container, dustParticleConfig)
}

export const updateParticles = () => {
	const now = performance.now()
	spritePool.dustEmitter?.update((now - elapsedDust) / 1000)
	elapsedDust = now
}

export default updateParticles
